import {HStack, Image, Menu, Portal, Box, Text, VStack, Icon, IconButton} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";
import AvatarPlaceholder from '@/assets/images/avatar_placeholder.svg';
import {useAuth} from '@/auth/AuthContext';
import {usePageHeader} from '@/components/layout/PageHeaderContext';
import {HiOutlineCpuChip, HiBars3} from "react-icons/hi2";

const TopBar = ({ onSidebarOpen }) => {
    const {t} = useTranslation("common");
    const {currentUser, logout} = useAuth();
    const header = usePageHeader();

    const displayName = currentUser
        ? `${currentUser.firstName} ${currentUser.lastName}`
        : '';

    const initials = currentUser
        ? `${currentUser.firstName?.[0] ?? ''}${currentUser.lastName?.[0] ?? ''}`.toUpperCase()
        : '';

    return (
        <HStack bg="bg.secondary" minH={20} w={'full'} justifyContent={'space-between'} alignItems={'center'} px={{ base: 3, md: 6 }} position={{ base: 'fixed', md: 'static' }} top={0} zIndex={10}>
            <HStack gap={2}>
                <IconButton
                    display={{ base: 'flex', md: 'none' }}
                    variant="ghost"
                    color="text.menu"
                    aria-label="Menu"
                    onClick={onSidebarOpen}
                >
                    <HiBars3 />
                </IconButton>
                <VStack alignItems="flex-start" gap={0}>
                    <HStack alignItems={'center'}>
                        {header.icon &&
                            <Icon size={'md'} color="text.user">
                                {header.icon}
                            </Icon>
                        }
                        {header.title && <Text bg="radial-gradient(circle, #ECEDFF, #C17EEB)" bgClip="text">{header.title}</Text>}
                    </HStack>
                    {header.subtitle && <Text color={"text.menu"}>{header.subtitle}</Text>}
                </VStack>
            </HStack>

            <Menu.Root>
                <Menu.Trigger asChild>
                    <HStack
                        as="button"
                        color={"text.user"}
                        columnGap={3}
                        transition="background 0.2s ease-in-out"
                        _hover={{bg: "border.primary", textDecoration: 'unset'}}
                        py={2}
                        pl={2}
                        pr={{ base: 2, md: 4 }}
                        borderRadius={32}
                        cursor="pointer"
                    >
                        {currentUser?.avatar ? (
                            <Image src={currentUser.avatar} w={8} borderRadius="full"/>
                        ) : (
                            <Box
                                w={8}
                                h={8}
                                borderRadius="full"
                                bg="purple.500"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <Text fontSize={12} color="white" fontWeight="bold">{initials ||
                                    <Image src={AvatarPlaceholder} w={8}/>}</Text>
                            </Box>
                        )}
                        <Text fontSize={16} display={{ base: 'none', md: 'block' }}>{displayName}</Text>
                    </HStack>
                </Menu.Trigger>
                <Portal>
                    <Menu.Positioner>
                        <Menu.Content>
                            <Menu.Item value="logout" onClick={logout}>
                                {t("actions.signOut")}
                            </Menu.Item>
                        </Menu.Content>
                    </Menu.Positioner>
                </Portal>
            </Menu.Root>
        </HStack>
    );
};

export default TopBar;
